import { Card, Divider, Tag, Table, Tabs, Input, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { retrieveAegisDependencies } from '../../methods/redux/reducers/compliance';

const { TabPane } = Tabs;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	gap: 1em;
`;

const AegisDependencies = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { aegisDependencies } = useAppSelector((store) => store.compliance);
	const [searchText, setSearchText] = useState('');

	useEffect(() => {
		dispatch(retrieveAegisDependencies());
	}, []);

	const formatData = (data: any) => {
		if (!data) return [];
		
		let list = [];
		if (Array.isArray(data)) {
			list = data;
		} else {
			list = Object.entries(data).map(([name, value]: any) => ({
				name,
				version: typeof value === 'object' ? value.version : value,
				type: typeof value === 'object' ? value.type : undefined,
			}));
		}

		return list.filter((item: any) => 
			item.name?.toLowerCase().includes(searchText.toLowerCase())
		);
	};

	const columns = [
		{
			title: 'Package Name',
			dataIndex: 'name',
			key: 'name',
			render: (name: string) => <strong>{name}</strong>,
		},
		{
			title: 'Version',
			dataIndex: 'version',
			key: 'version',
			render: (version: string) => <Tag color="blue">{version}</Tag>,
		},
	];

	return (
		<Container>
			<Card>
				<div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
					<Button 
						type="text" 
						icon={<ArrowLeftOutlined />} 
						onClick={() => navigate(-1)} 
						style={{ fontSize: '18px' }}
					/>
					<div>
						<h1>Aegis Dependency Inventory</h1>
						<p>Live inventory of project dependencies and version compliance.</p>
					</div>
				</div>
				<Divider />

				<Input
					placeholder="Search packages..."
					value={searchText}
					onChange={(e) => setSearchText(e.target.value)}
					style={{ marginBottom: '1em', maxWidth: '400px' }}
				/>

				<Tabs defaultActiveKey="1">
					<TabPane tab={`Production Dependencies (${Array.isArray(aegisDependencies?.dependencies) ? aegisDependencies.dependencies.length : Object.keys(aegisDependencies?.dependencies || {}).length})`} key="1">
						<Table
							columns={columns}
							dataSource={formatData(aegisDependencies?.dependencies)}
							rowKey="name"
							pagination={{ pageSize: 20 }}
						/>
					</TabPane>
					<TabPane tab={`Dev Dependencies (${Array.isArray(aegisDependencies?.devDependencies) ? aegisDependencies.devDependencies.length : Object.keys(aegisDependencies?.devDependencies || {}).length})`} key="2">
						<Table
							columns={columns}
							dataSource={formatData(aegisDependencies?.devDependencies)}
							rowKey="name"
							pagination={{ pageSize: 20 }}
						/>
					</TabPane>
				</Tabs>
			</Card>
		</Container>
	);
};

export default AegisDependencies;
